import gql from 'graphql-tag';

const ARTICLE_QUERY = gql`
    query Articles($slug: String!) {
        articleEntries (where: {slug: $slug}, limit: 1) {
            id
            slug
            title
            title_highlighted_words
            description
            published_at
            date
            categories {
                id
                title
            }
            hero {
                url
            }
            meta {
                page_title
                page_description
            }
            sections {
                title
                text
                title_highlighted_words
                quote {
                    text
                    author
                    image {
                        url
                    }
                }
                asset {
                    url
                    ext
                    caption
                    name
                    mime
                }
                youtubeVideo {
                    link
                    thumbnail {
                        url
                    }
                }
            }
            author {
                name
                title
                bio
                image {
                    url
                }
                link
            }
            relatedArticles_firstArticleId
            relatedArticles_secondArticleId
            action {
                title
                description
                route
                button_text
                disclaimer
            }
        }
    }
`;

export default ARTICLE_QUERY;
